const React = require('react');
const ReactDOM = require('react-dom');
const { createRoot } = require('react-dom/client');

import API from "./api";
import Constants from "./Constants";
import Session from "./session";

import BasicPage from "./BasicPageBody";

import Layout from "./components/stateless/Layout.jsx";
import InputContainer from "./components/stateful/forms/InputContainer.jsx";
import TagsList from "./components/stateless/TagsList.jsx";
import Button from "./components/stateless/Button.jsx";
import Popup from "./components/stateless/Popup.jsx";

/* Constant strings */
const titleUntilLoaded = "נא לחכות עד לטעינת הדף";
const subtitle = "נא למלא את הטופס במלואו";
const descriptionSubtitle = "יש לתאר את כל אשר קרה";


class Complaint extends BasicPage {
    constructor(props) {
        super(props);

        this.state = {
            schoolPrefs: undefined, // The prefernces of the school, including settings
            // (unsensitive ones) and terminology
            allStudents: undefined, // all the names and ids of the possible suers and sued
            // members of this school
            isLoading: true,
            isSubmitting: false, // whether the we are currently in the submittion
            notification: undefined,

            suers: [],       // A list of all suers objects
            sued: [],        // A list of all sued objects
            description: "",
            forMediation: "false",
            // authentication
            isAdminModalOpen: false,
            adminPass: "", // The current inserted admin password
            needsPassword: false, // Whether the school demands a password before submitting
            isLoggingIn: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.showAccessDeniedNotificationIfAny();

        // Load the school prefs. Whether we may load anything else depends on them.
        this.loadResource("schoolPrefs", Constants.fetch.GET_SCHOOL_ERR_MSG, API.getSchoolObj,
            {
                shouldUpdateLoadingState: true,
                onSuccess: school => this.onSchoolLoaded(school)
            });
    }

    // The server is what actually protects the member list. Prompting here just saves
    //  the user a failed request.
    onSchoolLoaded(school) {
        if (school.preferences.require_password && !Session.isLoggedIn()) {
            this.showPasswordGate();
            return;
        }
        this.loadMembers();
    }

    loadMembers() {
        this.loadResource("allStudents", Constants.fetch.GET_MEMBERS_ERR_MSG, API.getAllMembers,
            {
                shouldUpdateLoadingState: true,
                // The role cookie may outlive the session it describes
                onAuthError: () => this.showPasswordGate()
            });
    }

    showPasswordGate() {
        this.setState({needsPassword: true, isLoading: false});
    }

    // This function updates the isLoading state after a server AJAX call finishes.
    updateIsLoadingState() {
        const newVal = this.state.schoolPrefs == undefined ||
            (!this.state.needsPassword && this.state.allStudents == undefined);
        this.setState({
            isLoading: newVal
        });
    }

    /* * GENEREAL ADD\REMOVE FROM LISTS FUNCTIONS * */
    // toAdd is the whole object that has the key _id
    addToStateArr(toAdd, arrName) {
        this.setState({
            [arrName]: this.state[arrName].concat(toAdd) // The [arrName] syntax uses the value of
            // arrName as the object key
        });

        // Since we do not want to allow a student apearing multiple times,
        //  remove the recently added student from the available options.
        // The student will be returned to the autocomplete options if he'll
        //  get removed from the form.
        if (arrName != "allStudents")
            this.removeFromStateArr(toAdd._id, "allStudents");
    }

    // toRemove is the _id
    removeFromStateArr(toRemove, arrName) {
        const itemToRemove = this.state[arrName].find(item => item._id == toRemove);
        if (!itemToRemove) return;

        const newArr = this.state[arrName].filter(item => item._id != toRemove);
        
        this.setState({ [arrName]: newArr }, () => {
            // If we are about to remove from the suers or sued arrays, then the removed
            //  student should be added back to the available autocomplete options, as
            //  he was previously removed (see the end of the function 'addToStateArr')
            if (arrName != "allStudents") {
                this.addToStateArr(itemToRemove, "allStudents");
            }
        });
    }

    // Update the new description value after change
    onDescriptionChange(event) {
        const newValue = event.target.value;
        this.setState({ description: newValue });
    }

    onForMediationChange(event) {
        const newValue = event.target.value === "true" ? "false" : "true";
        this.setState({ forMediation: newValue });
    }

    onSubmit() {
        // First, if already submitting, don't repost
        if (this.state.isSubmitting)
            return;

        // Check all fields are filled
        if (this.state.suers.length == 0)
            this.setNotification("bad", Constants.frontEndErrors.NO_SUERS_ERR_START +
                this.state.schoolPrefs.terminology.suer +
                Constants.frontEndErrors.NO_SUERS_ERR_END);
        else if (this.state.sued.length == 0)
            this.setNotification("bad", Constants.frontEndErrors.NO_SUERS_ERR_START +
                this.state.schoolPrefs.terminology.sued +
                Constants.frontEndErrors.NO_SUERS_ERR_END);
        else if (this.state.description.trim() == "")
            this.setNotification("bad", Constants.frontEndErrors.NO_DESCRIPTION_ERR);
        else {
            // If here, it's alright
            this.setState({ isSubmitting: true });
            this.setNotification("natural", Constants.fetch.POSTING_WAIT_MSG);

            let mediation_text = "============ לגישור ==============" + "\n";

            API.postCase(this.schoolName, {
                suers: this.state.suers,
                sued: this.state.sued,
                description: (this.state.forMediation === "true" ? mediation_text : '') + this.state.description

            }, (resp) => { // response
                // Notify success
                this.setState({ isSubmitting: false });

                if (resp.responseCode == 200 || resp.responseCode == 304) {
                    this.setNotification("good", Constants.fetch.SUBMITTED_MSG);

                    // Clear form without race conditions
                    this.setState((prevState) => {
                        // Restore students to the available list safely
                        const restoredStudents = [...prevState.suers, ...prevState.sued];
                        const existingIds = new Set(prevState.allStudents.map(s => s._id.toString()));
                        
                        const trulyNewStudents = restoredStudents.filter(s => !existingIds.has(s._id.toString()));
                        
                        return {
                            suers: [],
                            sued: [],
                            allStudents: prevState.allStudents.concat(trulyNewStudents),
                            description: "",
                            forMediation: "false"
                        };
                    });

                }
                else
                    this.setNotification("bad", (resp.responseBody && resp.responseBody.message) ? resp.responseBody.message : resp.responseBody);
            }, this.reportSentAPIRequest());

        }

    }

    // authentication
    handleAdminDialogClose() { this.setState({ isAdminModalOpen: false }); }
    handleAdminDialogOpen() { this.setState({ isAdminModalOpen: true }); }
    updateAdminPass(event, { newValue }) {
        this.setState({ adminPass: newValue });
    }
    authenticate(e) {
        if(e && e.preventDefault)
            e.preventDefault();

        // Without this, two quick submits create two sessions - the browser keeps only
        //  the last cookie, so the rest stay valid and unreachable by logout - and two
        //  member loads whose different outcomes fight over needsPassword.
        if (this.state.isLoggingIn)
            return;

        this.setState({ isAdminModalOpen: false, isLoggingIn: true });
        this.setNotification("natural", Constants.fetch.VERIFYING_ADMIN_PASS_MSG);

        const password = this.state.adminPass;
        this.setState({ adminPass: "" });

        API.authenticate(this.schoolName, password, (resp) => {
            if (resp && (resp.responseCode == 200 || resp.responseCode == 304)) {
                // The password decides where we belong
                const role = resp.responseBody && resp.responseBody.role;
                const destination = Session.landingPathFor(role, this.schoolName, "admin");

                if (destination) {
                    window.location.replace(destination);
                    return;
                }

                // A user stays here and gets the form
                this.setState({ isLoggingIn: false });
                this.eraseNotification(Constants.fetch.VERIFYING_ADMIN_PASS_MSG);
                this.setState({ needsPassword: false, isLoading: true }, () => this.loadMembers());
            } else {
                this.setState({ isLoggingIn: false });
                this.setNotification("bad", Constants.adminLogin.INVALID_PASS_MSG);
            }

        }, this.reportSentAPIRequest());

    }

    // Shown instead of the form when the school demands a password
    renderPasswordGate(elementPrefix) {
        return (
            <form onSubmit={this.authenticate.bind(this)}>
                <InputContainer title={Constants.adminLogin.GATE_PASSWORD_LABEL}
                                description={Constants.adminLogin.GATE_SUBTITLE}
                                identifier={elementPrefix + "gate"}
                                type="password"
                                inputValue={this.state.adminPass}
                                valueUpdate={this.updateAdminPass.bind(this)} />
                <Button type="submit" onClick={this.authenticate.bind(this)}
                        useBootstrapWidthClasses={true} addMarginTop={true}>
                    {Constants.adminLogin.GATE_SUBMIT}
                </Button>
            </form>
        );
    }

    render() {
        let pageBody = "";
        let counter = 1;
        let element_prefix = "complaint_"; /* We need to append this to every ID in case we will reuse complaint in other
                                             pages. To keep the HTML ids unique */
        if (this.state.needsPassword)
            pageBody = this.renderPasswordGate(element_prefix);
        // If form should already be rendered
        else if (!this.state.isLoading)
            pageBody = (
                <span>
                    { /* Suers */}
                    <InputContainer title={this.state.schoolPrefs.terminology.suers}
                        description={"שמות כל ה" + this.state.schoolPrefs.terminology.suers + ". " +
                            Constants.info.AUTOCOMPLETE_USAGE_GUIDE}
                        identifier={ element_prefix+(counter++) }
                        shouldAutoComplete={true}
                        availableOptions={this.state.allStudents}
                        onOptionSelection={toAdd => this.addToStateArr(toAdd, "suers")}
                        resetOnSelection={true}
                    />
                    <TagsList items={this.state.suers}
                        areDeletables={true} onDelete={toRem => this.removeFromStateArr(toRem, "suers")}
                    />

                    { /* Sued */}
                    <InputContainer title={this.state.schoolPrefs.terminology.sueds}
                        description={"שמות כל ה" + this.state.schoolPrefs.terminology.sueds + ". " +
                            Constants.info.AUTOCOMPLETE_USAGE_GUIDE}
                        identifier={ element_prefix+(counter++) }
                        shouldAutoComplete={true}
                        availableOptions={this.state.allStudents}
                        onOptionSelection={toAdd => this.addToStateArr(toAdd, "sued")}
                        resetOnSelection={true}
                    />
                    <TagsList items={this.state.sued}
                        areDeletables={true} onDelete={toRem => this.removeFromStateArr(toRem, "sued")}
                    />

                    { /* Description */}
                    <InputContainer title={"תיאור ה" + this.state.schoolPrefs.terminology.case}
                        description={descriptionSubtitle}
                        identifier={ element_prefix+(counter++) }
                        isTextArea={true}
                        valueUpdate={this.onDescriptionChange.bind(this)}
                        inputValue={this.state.description} />

                    { // Add option to submit as mediation if the school enabled it

                        this.state.schoolPrefs.preferences.allow_submit_as_mediation_option &&
                        <InputContainer title={""}
                                        description={"גישורי?"}
                                        inputValue={ this.state.forMediation }
                                        type="checkbox"
                                        identifier={ element_prefix+(counter++) }
                                        valueUpdate={this.onForMediationChange.bind(this)} />
                    }


                    <Button onClick={this.onSubmit.bind(this)} isDisabled={this.state.isSubmitting} useBootstrapWidthClasses={true} addMarginTop={true}>הגש</Button>

                    <a href={"/" + this.state.schoolPrefs.name + "/appeal"}>
                        <Button isDisabled={this.state.isSubmitting} useBootstrapWidthClasses={true} addMarginTop={true}>למערכת {this.state.schoolPrefs.terminology.appeal_committee}</Button>
                    </a>

                    <Button onClick={this.handleAdminDialogOpen.bind(this)} isDisabled={this.state.isSubmitting} useBootstrapWidthClasses={true} addMarginTop={true}>ממשק מנהל</Button>
                    {
                        this.state.isAdminModalOpen &&
                        <Popup onClose={this.handleAdminDialogClose.bind(this)}
                            title={Constants.adminLogin.ADMIN_DIALOG_TITLE}
                            subtitle={Constants.adminLogin.ADMIN_DIALOG_SUBTITLE}>

                            <form onSubmit={this.authenticate.bind(this)} >
                                <InputContainer title="סיסמת כניסה" identifier={ element_prefix+(counter++) }
                                        inputValue={this.state.adminPass}
                                        type="password"
                                                valueUpdate={this.updateAdminPass.bind(this)} />
                                <Button type="submit" onClick={this.authenticate.bind(this)} useBootstrapWidthClasses={true} addMarginTop={true}>הכנס</Button>
                            </form>
                        </Popup>
                    }

                </span>
            );

        return (
            <Layout title={this.state.needsPassword ?
                Constants.adminLogin.GATE_TITLE :
                (this.state.isLoading ?
                    titleUntilLoaded :
                    "הגשת " + this.state.schoolPrefs.terminology.case)
            }
                subtitle={this.state.needsPassword ? Constants.adminLogin.GATE_SUBTITLE : subtitle}
                notification={this.state.notification}
                isLoading={this.state.isLoading}>
                {pageBody}
            </Layout>
        );
    }
}

const root = createRoot(document.getElementById('app'));
root.render(<Complaint />);
